// extracted by mini-css-extract-plugin
export default {"mainSection":"SectionInfo_mainSection__2EUvB","subTitle":"SectionInfo_subTitle__djctR","title":"SectionInfo_title__OxEAW","description":"SectionInfo_description__5zzOC"};